// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-pages-CaseStudy----CaseStudy-module---wrapper---Z6h9k","content":"src-components-pages-CaseStudy----CaseStudy-module---content---1WXhc","studyList":"src-components-pages-CaseStudy----CaseStudy-module---studyList---1Exz0","studyItem":"src-components-pages-CaseStudy----CaseStudy-module---studyItem---3XA9n","studyTitle":"src-components-pages-CaseStudy----CaseStudy-module---studyTitle---w3c-y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/CaseStudy/CaseStudy.module.sass
// module id = 140
// module chunks = 156023263309555 208176855801404